import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subscription, Subject, takeUntil, take, finalize, debounceTime, distinctUntilChanged, filter, switchMap, catchError, of } from 'rxjs';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ServicosIniciaisService } from 'src/app/modules/services/servicos-iniciais/servicos-iniciais.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';

import { FeriadoService } from 'src/app/modules/services/feriado/feriado.service';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingService } from '../../../loading/loading.service';

@Component({
  selector: 'app-feriado-form',
  templateUrl: './feriado-form.component.html',
  styleUrls: ['./feriado-form.component.scss']
})
export class FeriadoFormComponent {
 @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  feriadoId: string | null = '';
  isEditMode: boolean = false;
  form!: FormGroup;
  //Escopo 
  searchControlEscopo = new FormControl();
  tiposFeriados: any[] = [];
  selectedOptionEscopo: any;
  //Tipo de servico
  searchControlTipoServico = new FormControl();
  filteredOptionsTipoServico: any[] = [];
  selectedOptionTipoServico: any;
  //Tabela 
  displayedColumns: string[] = [];
  sortState = {
    sortProperty: 'escopo',
    sortDirection: 'asc'
  };
  screenWidth: number = window.innerWidth;
  columnConfig = [
    { columnDef: 'escopo', header: 'Área Funcional', property: 'escopo.nome' },
    { columnDef: 'servico', header: 'Tipo Serviço', property: 'tipoServico.nome' },
    { columnDef: 'parametroDesempenho', header: 'Parâmetro', property: 'parametroDesempenho' },
    { columnDef: 'fimPrazoAtendimento', header: 'Prazo de Atendimento', property: 'fimPrazoAtendimento', customTd:true },
    { columnDef: 'valor', header: 'Valor', property: 'valor', customTd:true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];
  canEdit: boolean = true;
  canDelete: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalPages: number = 1;
  totalElements: number = 0;
  dataSource = new MatTableDataSource<any>([]);
  subsctiptions: Subscription[] = [];  
  filterParametro:string = '';
  filterData:any;
  idServicoInicial:string | null = '';
  criterios:any = [];
  criteriosLabels!: { [key: string]: string; };
  formFeriado!: FormGroup;
  private destroy$ = new Subject<void>();
  constructor(

    private fb: FormBuilder,
    private snackbarService: OpenSnackbarService,
    private feriadoService: FeriadoService,
    private pageStateService: PageStateService,
    private pageSizeService: PageSizeService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,    
    private authService: AuthService,
    private userService: UserService,
  ) {
    this.createForm();
    this.formFeriado = this.fb.group({
      descricao: [''],
      tipoFeriado: [''],
      dataInicio: [''],
      dataFim: [''],
      periodo: [false],
      recorrente: [''],
      
    });
    this.loadUserInfo();
  }
    ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.feriadoId = params.get('id');
      if(this.feriadoId){
        this.isEditMode = true;
         this.getFeriado();
      }
    });
    this.getAllData();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAllData() {

    this.feriadoService.getTiposFeriado().subscribe({
      next: (res: any) => {
        this.tiposFeriados = res;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });
  }
  onCheckboxKeydown($event: any) {
    const inicioPrazoAtendimentoControl = this.form.get('inicioPrazoAtendimento');
     const fimPrazoAtendimentoControl = this.form.get('fimPrazoAtendimento');
    const medidaInicioControl = this.form.get('medidaInicioPrazoAtendimento');
    const medidaFimControl = this.form.get('medidaFimPrazoAtendimento');

    if(!$event.detail.checked){
      if(medidaInicioControl){
         medidaInicioControl.setValue('Dias', { emitEvent: false });
      }
      if(medidaFimControl){
        medidaFimControl.setValue('Dias', { emitEvent: false });
      }
      if(inicioPrazoAtendimentoControl){
        inicioPrazoAtendimentoControl.setValue('', { emitEvent: false });
      }
      if(fimPrazoAtendimentoControl){
        fimPrazoAtendimentoControl.setValue('', { emitEvent: false });
      }
    }
  }
  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }
  checkFunctionality(functionality: any) {

    if (functionality.url === '/contratos') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }
  // Listar Registros gerais

  getFeriado(){
    this.feriadoService.getFeriado(this.feriadoId).subscribe({
      next: (res: any) => {
        this.patchValue(res);
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });
  }
  handleSubmit(){
    this.feriadoId ? this.edit() : this.create();
  }
  create() {
    const form = this.form.value;
    this.form.markAllAsTouched();
    this.loadingService.showLoading();
    this.feriadoService.create(form).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ) .subscribe(
      (response: any) => {
        this.toastService.showSuccess(response.message);
            this.router.navigate([`feriados`]);
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    )
  }
  edit(){
    const form = this.form.value;
    this.loadingService.showLoading();
    this.feriadoService.edit(form, this.feriadoId).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ) .subscribe(
      (response: any) => {
        this.toastService.showSuccess('Feriado editado com sucesso.');
        this.router.navigate([`feriados`]);
      },
      (erro:any) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    )
  }

  createForm(){
    this.form = this.fb.group({
      descricao: ['', Validators.required],
      tipoFeriado: ['', Validators.required],
      dataInicio: ['', Validators.required],
      dataFim: [''],
      periodo: [false],
      recorrente: [false],
    })
  }
  patchValue(data:any){
    this.form.patchValue({
      descricao: data.descricao,
      tipoFeriado: data.tipoFeriado.valor,
      dataInicio: data.dataInicio,
      dataFim: data.dataFim,
      periodo:  data.dataInicio && data.dataFim ? true : false,
      recorrente: data.recorrente ? true : false,
    })
  }



  onMedidaValorChange(valorSelecionado: string) {
    const campo = this.form.get('valor');
  
    if (valorSelecionado === 'Existe' || valorSelecionado === 'Não Existe') {
      campo?.reset(); 
      campo?.disable();
    } else {
      campo?.enable();
    }
  }
  openSnackBar(description: string, type: string) {
      let classSnack = '';
      switch (type) {
        case 'sucess':
          classSnack = 'snacbar-sucess';
          break;
        case 'warning':
          classSnack = 'snacbar-warning';
          break;
        case 'error':
          classSnack = 'snacbar-error';
          break;
      }
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description: description, type: type },
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
  }

  preventNegativePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (isNaN(Number(pasted)) || Number(pasted) < 0) {
      event.preventDefault();
    }
  }

  blockNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '—') {
      event.preventDefault();
    }
  }
  back(){
    this.router.navigate([`feriados`]);
  }
}
